/**
 * product-list.js
 * - フィルターURL管理
 * - URLパラメータによる商品の表示/非表示（JSで処理）
 * - ランダムサムネイル
 * - 画像フェードイン（チラつき防止）
 */

// フィルター適用（現在のパラメータを保持しつつ指定パラメータを更新）
function applyFilter(param, value) {
  const url = new URL(window.location.href);
  if (value === '') {
    url.searchParams.delete(param);
  } else {
    url.searchParams.set(param, value);
  }
  window.location.href = url.toString();
}

document.addEventListener('DOMContentLoaded', function () {

  const params     = new URLSearchParams(window.location.search);
  const catFilter  = params.get('product_cat')  || '';
  const itemFilter = params.get('product_item') || '';

  // ── フィルターボタンのアクティブ状態を更新 ──
  document.querySelectorAll('[data-filter-param]').forEach(function (btn) {
    const current = params.get(btn.dataset.filterParam) || '';
    btn.classList.toggle('is-active', btn.dataset.filterValue === current);
  });

  // ── 商品の表示/非表示 + 画像設定 ──
  let visibleCount = 0;

  document.querySelectorAll('.product-card').forEach(function (card) {
    const cats  = card.dataset.categories || '';
    const items = card.dataset.items      || '';

    const showCat  = !catFilter  || cats.split('|').includes(catFilter);
    const showItem = !itemFilter || items.split('|').includes(itemFilter);
    const show     = showCat && showItem;

    card.style.display = show ? '' : 'none';
    if (!show) return;
    visibleCount++;

    const img = card.querySelector('.product-card__image');
    if (!img) return;

    // ランダムサムネイル
    const images = (card.dataset.variantImages || '').split('|').filter(Boolean);
    img.src = images.length > 0
      ? images[Math.floor(Math.random() * images.length)]
      : card.dataset.defaultSrc || '';

    // フェードイン
    function revealImage() { img.classList.add('is-loaded'); }
    if (img.complete && img.naturalWidth > 0) {
      revealImage();
    } else {
      img.addEventListener('load',  revealImage);
      img.addEventListener('error', revealImage);
    }
  });

  // 0件メッセージ
  const noProductsEl = document.getElementById('noProducts');
  if (noProductsEl) noProductsEl.style.display = visibleCount === 0 ? '' : 'none';

});
